// extracted by mini-css-extract-plugin
export default {"wrapper":"GetStarted_wrapper__xLUJc","title":"GetStarted_title__XcANF","tabsList":"GetStarted_tabsList__9MwlI","tab":"GetStarted_tab__Mf1U-"};